import ProviderWrapper from './src/store/ProviderWrapper';

export const wrapRootElement = ProviderWrapper;
